import ExampleHeader from '@/components/ExampleHeader.vue';

export default {
  components: {
    ExampleHeader,
  },
  data() {
    return {
      count: 0,
      initialItems: 9,
      items: [],
      showingCode: false,
    };
  },
  created() {
    [...Array(this.initialItems).keys()].forEach(() => this.addItem());
  },
  computed: {
    toggleText() {
      return this.showingCode ? 'Show Grid' : 'Show Code';
    },
  },
  methods: {
    getRand(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    createItem() {
      this.count = this.count + 1;
      return { id: this.count };
    },
    addItem() {
      this.showingCode = false;
      this.items.push(this.createItem());
    },
    removeLastItem() {
      this.showingCode = false;
      this.items.splice(this.items.length - 1);
    },
    removeItem(id) {
      this.showingCode = false;
      const index = this.items.findIndex(item => item.id === id);
      this.items.splice(index, 1);
    },
    shuffleItems() {
      this.showingCode = false;
      this.items = this.items
        .map(a => [Math.random(), a])
        .sort((a, b) => a[0] - b[0])
        .map(a => a[1]);
    },
    toggleCode() {
      this.showingCode = !this.showingCode;
    },
  },
};
